import { Injectable } from '@angular/core';
import { App, AppInfo } from '@capacitor/app';

/**
 * @description
 * Wrapper service for Capacitor's App plugin.
 * Provides an abstraction layer to interact with app-specific metadata and states,
 * reducing direct coupling with the Capacitor plugin across the application.
 */
@Injectable({
  providedIn: 'root',
})
export class AppService {
  /**
   * Retrieves detailed information about the current application.
   *
   * @returns {Promise<AppInfo>} A promise that resolves with the application's metadata (e.g., version, build, bundle ID).
   */
  public getInfo(): Promise<AppInfo> {
    return App.getInfo();
  }
}
